export default __webpack_public_path__ + "static/media/Hauora-Light.e887ae15.woff2";